/* eslint-disable react/destructuring-assignment */
/* eslint-disable arrow-body-style */
/* eslint-disable camelcase */
import { useState, useEffect } from 'react';
import { Box } from '@mui/system';
import { Link as MuiLink, Typography, Table, TableBody, TableCell, TableHead, TableRow, IconButton, Collapse } from '@mui/material';

import usePermission from 'hooks/usePermission';

import * as React from 'react';

import { Link } from 'react-router-dom';
import { encriptId } from 'utils/encription';
import { useLazyGetPdcGoalReportsQuery } from 'store/services/reports/pdcGoalReport';

import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import Spinner from 'ui-component/Spinner';
// eslint-disable-next-line arrow-body-style

export const Row = ({ filters, row }) => {
    const { hasPermission } = usePermission();
    const [trigger, { data: reportData, isFetching: reportLoading }] = useLazyGetPdcGoalReportsQuery();

    const [isCollapseOpen, setCollapseOpen] = useState(false);

    useEffect(() => {
        setCollapseOpen(false);
    }, [filters]);
    
    return (
        <>
            {reportLoading && <Spinner />}
            <TableRow>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={async () => {
                            if (!isCollapseOpen) {

                                await trigger({
                                    filters: {
                                        ...filters,
                                        is_detail: 1,
                                        patient_id: row?.student_id,
                                        goal_id: row?.goal_id,
                                        // location_ids:[row?.location_id]
                                    },
                                    pagination: {
                                        current_page: 1
                                    }
                                });
                            }

                            setCollapseOpen(!isCollapseOpen);
                        }}
                    >
                        {isCollapseOpen ? <RemoveIcon /> : <AddIcon />}
                    </IconButton>
                </TableCell>

                <TableCell> {row?.goal_id}</TableCell>
                <TableCell> {row?.description}</TableCell>
                <TableCell> {row?.status}</TableCell>
                <TableCell> {row?.total_success_count}</TableCell>
                <TableCell> {row?.total_attempt_count}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={isCollapseOpen} timeout="auto" unmountOnExit>
                        <Box sx={{ marginLeft: '50px', marginBottom: 1 }}>
                            <Table
                                aria-label="purchases"
                                sx={{
                                    borderBottom: (theme) => `0px solid ${theme.palette.grey[400]}`
                                }}
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Class Room</TableCell>
                                        <TableCell>Location</TableCell>
                                        <TableCell>Goal Result</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <>
                                        {reportLoading ? (
                                            <Spinner />
                                        ) : (
                                            reportData?.fields?.map((row, index) => (
                                                <TableRow key={index}>
                                                    <TableCell component="th" scope="row">
                                                        {row?.date}
                                                    </TableCell>
                                                    <TableCell>{row?.classroom}</TableCell>                                              
                                                    <TableCell>{row?.location}</TableCell>
                                                    <TableCell>{row?.goal_success}</TableCell>                                
                                                </TableRow>
                                            ))
                                        )}
                                    </>
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};
